import { Validators } from '@angular/forms';
import { FormField } from 'ngx-smart-form';
import { AddressFormData } from '../_widgets/address-form/address-form-data';
import { EditableField } from '../_widgets/address-form/editable-field';
import { PraticaType } from '../../interfaces/pratica';

export const getSedeLegaleLocationFields = (praticaType?: PraticaType) => {
  const required = praticaType !== 'AML';
  const SEDE_LEGALE_LOCATION_FIELDS: FormField<AddressFormData>[][] = [
    [
      new EditableField({
        formControlName: 'country',
        label: 'Stato',
        required: true,
      }),
      new EditableField({
        formControlName: 'administrative_area_level_2',
        label: 'Sigla provincia',
        validators:
          praticaType !== 'AML'
            ? [Validators.minLength(2), Validators.maxLength(2)]
            : [],
        required,
      }),
    ],
    [
      new EditableField({
        formControlName: 'administrative_area_level_3',
        label: 'Città',
        required,
      }),
      new EditableField({
        formControlName: 'route',
        label: 'Indirizzo',
        required,
      }),
    ],
    [
      new EditableField({
        formControlName: 'street_number',
        label: 'Numero civico',
        required,
      }),
      new EditableField({
        formControlName: 'postal_code',
        label: 'Cap',
        required,
      }),
    ],
  ];
  return SEDE_LEGALE_LOCATION_FIELDS;
};
